
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.213 12.464c0-1.322.608-2.286 1.786-3.036-.678-.964-1.678-1.464-3-1.571-1.285-.107-2.678.714-3.178.714-.536 0-1.75-.678-2.714-.678-2 .035-4.107 1.57-4.107 4.75 0 .928.143 1.892.5 2.892.464 1.321 2.107 4.535 3.821 4.464.893 0 1.536-.643 2.714-.643 1.143 0 1.714.643 2.714.643 1.75 0 3.25-2.928 3.679-4.25-2.322-1.107-2.215-3.214-2.215-3.285zm-2-5.857c.965-1.143.858-2.214.858-2.607-.857.071-1.857.607-2.429 1.25-.643.714-1 1.607-.928 2.571.928.072 1.785-.393 2.5-1.214z","fill":"#fff"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      